import { AsyncPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatIconButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { VmpSelectionType } from '../../enums';
import { BaseEdit } from '../base-edit';

@Component({
  selector: 'ldw-lookup-edit',
  templateUrl: './lookup-edit.component.html',
  styleUrls: ['./lookup-edit.component.css'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatIcon,
    MatPrefix,
    MatTooltip,
    MatInput,
    MatAutocompleteTrigger,
    MatIconButton,
    MatSuffix,
    MatAutocomplete,
    MatOption,
    AsyncPipe,
    TranslatePipe
  ]
})
export class LookupEditComponent extends BaseEdit {
  readonly clearButtonEnabled = input(true);
  readonly AutoCompleteEnabled = input(false);

  autoCompleteValues: string[] | undefined = undefined;

  get autoCompleteItems$(): Observable<string[]> {
    if (this.autoCompleteValues != undefined) {
      return of(this.autoCompleteValues);
    }

    if (!this.isAutoComplete) {
      this.autoCompleteValues = [];
    } else {
      this.autoCompleteValues = []; // ['hello', 'test', 'blue'];
    }
    return of(this.autoCompleteValues);
  }

  get isAutoComplete(): boolean {
    if (this.AutoCompleteEnabled()) {
      // control property overrides VMP property
      return true;
    }
    if (this.isBound) {
      return this.vmp?.selectionType == VmpSelectionType.AutoComplete;
    }
    return false;
  }

  clearText(): void {
    this.internalControl?.reset('');
  }
}
